import { createContext, useContext, type ReactNode } from 'react';

export interface MentionPerson {
  userId: string;
  name: string;
  avatarUrl?: string;
  title?: string;
}

const MentionContext = createContext<MentionPerson[]>([]);

/** Tells every rich-text editor below it who can be @mentioned (e.g. the members of the current project). */
export function MentionProvider({ people, children }: { people: MentionPerson[]; children: ReactNode }) {
  return <MentionContext.Provider value={people}>{children}</MentionContext.Provider>;
}

export const useMentionPeople = () => useContext(MentionContext);

/** Ids of everyone @mentioned in a piece of rich-text HTML. */
export function extractMentionIds(html: string): string[] {
  if (!html) return [];
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return Array.from(new Set(Array.from(doc.querySelectorAll('[data-user-id]')).map((el) => el.getAttribute('data-user-id') || '').filter(Boolean)));
}
